import { render, staticRenderFns } from "./ZModal.vue?vue&type=template&id=1861030c&scoped=true&"
import script from "./ZModal.vue?vue&type=script&lang=js&"
export * from "./ZModal.vue?vue&type=script&lang=js&"
import style0 from "./ZModal.vue?vue&type=style&index=0&id=1861030c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1861030c",
  null
  
)

export default component.exports